const changeCheckboxesToBoolean = (formData: any) => {
    for (const pair of formData.entries()) {
        if (pair[1] === 'on') {
            formData.set(pair[0], true);
        }
    }
    return formData;
};

export default changeCheckboxesToBoolean;
